// src/utils/i18nBackend.js
import i18n from "@/i18n";

export function localizeField(item, fieldBase) {
  if (!item) return "";

  const lang = i18n.language?.toLowerCase().startsWith("ar") ? "ar" : "en";

  return item[`${fieldBase}_${lang}`] || item[`${fieldBase}_en`] || "";
}